import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, map } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { OrganizationRepository } from '../../../repository/organization.repository';
import { SupervisorRepository } from '../../../repository/supervisor.repository';
import {
  getOrganizationFailureAction,
  getOrganizationLeadSupervisorFailureAction,
  getOrganizationLeadSupervisorSuccessAction,
  getOrganizationSuccessAction,
  setOpportunityDataAction
} from '../opportunity-config.actions';


@Injectable()
export class GetOrganizationAndLeadOrgSupervisorEffect {
  private actions$ = inject(Actions);
  private organizationRepo = inject(OrganizationRepository);
  private supervisorRepo = inject(SupervisorRepository);

  getOrganization$ = createEffect(() => this.actions$.pipe(
    ofType(setOpportunityDataAction),
    exhaustMap((action) => this.organizationRepo.getOrganization(action.opportunity.organizationId).pipe(
      map(organization => getOrganizationSuccessAction({ organization })),
      catchError(error => of(getOrganizationFailureAction({ error })))
    ))
  ));

  getLeadSupervisor$ = createEffect(() => this.actions$.pipe(
    ofType(getOrganizationSuccessAction),
    exhaustMap((action) => this.supervisorRepo.getSupervisor(action.organization.supervisorId).pipe(
      map(supervisor => getOrganizationLeadSupervisorSuccessAction({ supervisor })),
      catchError(error => of(getOrganizationLeadSupervisorFailureAction({ error })))
    ))
  ));
}
